import { ResolveFn } from '@angular/router';
import { RestoreTaskService } from '../services/restore-task.service';
import { inject } from '@angular/core';
import { RestoreTaskSummaryDTO } from '../../shared/models/backups.models';
import { WebsiteStoreService } from '../services/website-store.service';
import { WebsiteData } from '../../shared/models/website-overview.model';
import { forkJoin, of } from 'rxjs';
import moment from 'moment';

export const websiteRestoreResolver: ResolveFn<{
  restoreTask: RestoreTaskSummaryDTO;
  websiteData: WebsiteData | null;
}> = (route) => {
  const restoreService = inject(RestoreTaskService);
  const websiteStore = inject(WebsiteStoreService);

  const restoreId = +route.paramMap.get('restoreId')!;
  const websiteIdParam = route.paramMap.get('websiteId');

  const restoreTask$ = restoreService.getRestoreTask(restoreId);

  // No websiteId → only load the restore task
  if (websiteIdParam === null) {
    return forkJoin({
      restoreTask: restoreTask$,
      websiteData: of(null),
    });
  }

  return forkJoin({
    restoreTask: restoreTask$,
    websiteData: websiteStore.loadWebsiteData(
      +websiteIdParam,
      moment().utc().startOf('month').unix(),
      moment().utc().endOf('month').unix(),
    ),
  });
};
